(() => {
  function init() {
    const price = document.querySelector('.product-price');
    if (!price || price.dataset.memberCompactReady) return;
    price.dataset.memberCompactReady = 'true';
    let pending = false;
    function arrange() {
      pending = false;
      const container = document.querySelector('.tier-pricing-container');
      if (!container) return;
      price.classList.add('member-price-compact');
      if (!price.contains(container)) {
        const block = container.closest('.product-info__block');
        price.append(container);
        if (block && !block.textContent.trim()) block.hidden = true;
      }
      const prompt = container.querySelector('.tier-pricing-login-prompt');
      if (prompt) {
        const title = prompt.querySelector('.login-prompt-title');
        const link = prompt.querySelector('.login-button');
        if (title && title.textContent !== '會員買更划算') title.textContent = '會員買更划算';
        if (link && !prompt.querySelector('.member-tier-benefits')) {
          const details = document.createElement('details');
          details.className = 'member-tier-benefits';
          details.innerHTML = `
            <summary>登入／註冊</summary>
            <div class="member-tier-benefits__panel">
              <p class="member-tier-benefits__heading">會員價格優惠</p>
              <dl>
                <div><dt>青銅會員</dt><dd>一般商品價格</dd></div>
                <div><dt>白銀會員</dt><dd>會員優惠 1%</dd></div>
                <div><dt>黃金會員</dt><dd>會員優惠 3%</dd></div>
                <div><dt>鑽石會員</dt><dd>會員優惠 5%</dd></div>
              </dl>
              <p class="member-tier-benefits__note">實際優惠依會員等級與商品適用規則為準。</p>
            </div>`;
          prompt.append(details);
          link.textContent = '登入／註冊 →';
          details.querySelector('.member-tier-benefits__panel').append(link);
          const hover = window.matchMedia('(hover: hover)');
          details.addEventListener('pointerenter', () => {
            if (hover.matches) details.open = true;
          });
          details.addEventListener('pointerleave', () => {
            if (hover.matches && !details.contains(document.activeElement)) details.open = false;
          });
          details.addEventListener('focusout', () => {
            requestAnimationFrame(() => {
              if (!details.contains(document.activeElement) && !details.matches(':hover')) details.open = false;
            });
          });
          details.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
              details.open = false;
              details.querySelector('summary').focus();
            }
          });
        }
      }
      const redundant = !!container.dataset.customerId && !!price.querySelector('.tier-progressive-display');
      if (container.hidden !== redundant) container.hidden = redundant;
    }
    const observer = new MutationObserver(() => {
      if (!pending) {
        pending = true;
        requestAnimationFrame(arrange);
      }
    });
    observer.observe(price.closest('.product-info') || price.parentElement, { childList: true, subtree: true });
    arrange();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
